import {get} from "lodash"
import BaseService from "./Base"
import {StudentStatus} from "types/students"

export type AutoAssignedStudentStatuses = {
    autoAssignStatusOnFirstAttendanceLogged: StudentStatus | null
    autoAssignStatusOnHoursCompleted: StudentStatus | null
}

export type SaveAutoAssignedStudentStatusesPayload = {
    autoAssignStatusOnFirstAttendanceLoggedStatusId: number | null
    autoAssignStatusOnHoursCompletedStatusId: number | null
}

class SettingStudentStatusService extends BaseService {
    async getAllStatuses(params = {}): Promise<{total: number; data: StudentStatus[]}> {
        const response = await this.post("/v1/settings/student-statuses/list", params)
        return get(response, "data", {})
    }

    async createStatus(params = {}) {
        const response = await this.post("/v1/settings/student-statuses/create", params)
        return get(response, "data.data", {})
    }

    async updateStatus(id, data, params = {}) {
        data.statusId = id
        const response = await this.post(`/v1/settings/student-statuses/edit`, data, params)
        return get(response, "data", {})
    }

    async deleteStatus(statusIds) {
        const response = await this.post(`/v1/settings/student-statuses/delete`, {statusIds})
        return get(response, [], {})
    }

    async getAutoAssignedStudentStatuses(): Promise<AutoAssignedStudentStatuses> {
        const response = await this.post(`/v1/settings/student-statuses/auto-assigned/get`, {})
        return get(response, "data.data", {
            autoAssignStatusOnFirstAttendanceLogged: null,
            autoAssignStatusOnHoursCompleted: null
        })
    }

    async saveAutoAssignedStudentStatuses(payload: SaveAutoAssignedStudentStatusesPayload): Promise<void> {
        await this.post(`/v1/settings/student-statuses/auto-assigned/save`, payload)
    }

    async saveStudentStatusesAutoAssignedToCancelledOrDroppedProfiles(
        payload: Record<"prospect" | "applicant" | "student", number | null>
    ): Promise<void> {
        await this.post(`/v1/settings/student-statuses/auto-assigned-to-cancelled-or-dropped-profiles/save`, payload)
    }
}

export default SettingStudentStatusService
